import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Grid } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import "../MembershipPage.css";
import { withRouter } from "react-router-dom";
import MembershipPlanCard from "./MembershipPlanCard";
import MembershipFAQ from "./MembershipFAQ";
import HgSuperPayAddonSection from "./HgSuperPayAddonSection";
import BusinessIcon from "@material-ui/icons/Business";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import StarIcon from "@material-ui/icons/Star";

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
});

@inject("userStore", "profileStore", "hgBillingStore")
@withRouter
@observer
class VenueGroupBilling extends Component {
    constructor(props) {
        super(props);
    }

    state = {};

    render() {
        const { billingAccess } = this.props.hgBillingStore;

        var isFreePlan = !billingAccess ? true : false || billingAccess?.isFreePlan;
        var isBasicPlan = billingAccess?.isBasicPlan;
        var isProPlan = billingAccess?.isProPlan;

        const freeFeatures = [
            "Create & manage your venue profile",
            "Up to 8 bookings per month",
            "Unlimited staff with role-based permissions",
            "Act roster management incl. venue favourites",
            "Act availability visibility",
            "Integrated worksheets & contracts",
            "Cancellation workflows",
            "Automated artist invoicing",
            "Spend vs budget reporting"
        ];

        const essentialsFeatures = [
            "Unlimited bookings",
            "Invite agents to manage your entertainment",
            "Automated gig promotion - website & screens",
            "Social post management for both live events and general social posts"
        ];

        const proFeatures = [
            "Accounting Package Integrations including XERO & MYOB (Quickbooks coming soon)"
        ];

        const venueFAQs = [
            {
                question: "Can I change my plan at any time?",
                answer: "Yes, you can upgrade or downgrade your plan at any time. Contact our sales team and changes will be arranged promptly."
            },
            {
                question: "What does POA mean?",
                answer: "POA stands for Price On Application. Venue group pricing is tailored to your organisation's size and needs. Contact our sales team for a custom quote."
            },
            {
                question: "What happens to my data if I downgrade?",
                answer: "Your data is always safe. If you downgrade, you'll retain access to all your historical data, but some premium features may become unavailable."
            },
            {
                question: "How do I get started with a Venue Group plan?",
                answer: "Simply click 'Contact HG Sales' on the plan that interests you and our team will be in touch to discuss your requirements and arrange pricing."
            }
        ];

        return (
            <Fragment>
                <div className="membership-container">
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="membership-grid">
                                <MembershipPlanCard
                                    planType="free"
                                    planName="Free"
                                    tagline="Get started with the basics"
                                    icon={<BusinessIcon style={{ fontSize: 24 }} />}
                                    features={freeFeatures}
                                    contactSalesUrl={`mailto:sales@hotgiggity.com?subject=${encodeURIComponent("Downgrade to Free Plan")}`}
                                    isCurrentPlan={isFreePlan}
                                />

                                <MembershipPlanCard
                                    planType="essentials"
                                    planName="Essentials"
                                    tagline="Everything in Free plus:"
                                    icon={<TrendingUpIcon style={{ fontSize: 24 }} />}
                                    features={essentialsFeatures}
                                    contactSalesUrl={`mailto:sales@hotgiggity.com?subject=${encodeURIComponent("Upgrade to Essential Plan")}`}
                                    isCurrentPlan={isBasicPlan}
                                />

                                <MembershipPlanCard
                                    planType="pro"
                                    planName="Pro"
                                    tagline="Everything in Essentials plus:"
                                    icon={<StarIcon style={{ fontSize: 24 }} />}
                                    features={proFeatures}
                                    contactSalesUrl={`mailto:sales@hotgiggity.com?subject=${encodeURIComponent("Upgrade to Pro Plan")}`}
                                    isCurrentPlan={isProPlan}
                                    highlighted={true}
                                />
                            </div>

                            <div style={{ padding: "0 0 8px" }}>
                                <HgSuperPayAddonSection />
                            </div>
                            <MembershipFAQ faqItems={venueFAQs} />
                        </Grid>
                    </Grid>
                </div>
            </Fragment>
        );
    }
}

export default withStyles(styles)(VenueGroupBilling);
